import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { AuthApiService } from './auth-api.service';
import { IUsuario } from '../nucleo/interface/dto/IUsuario';
import { Constante } from '../nucleo/constante/constante';
import { IPermiso } from '../nucleo/interface/dto/IPermiso';
import { IResponseData } from '../nucleo/interface/dto/IResponseData';


@Injectable()
export class AutenticacionService {
  readonly path = 'seguridad';

  constructor(private router: Router,
    private authApiService: AuthApiService,
    private http: HttpClient) {

  }

  login(usuario: IUsuario): Observable<HttpResponse<IResponseData>>{
    return this.authApiService.login(this.path, usuario).pipe(map((response: HttpResponse<IResponseData>) => {
      if (response) {
        if (response.body.codigo === Constante.RESPUESTA_OK) {
          //this.cargarTokenSeguridad(response);
          return response;
        } else {
          this.borrarSessionStorage();
          return response;
        }
      } else {
        this.borrarSessionStorage();
        return response;
      }
    }));
  }

  private cargarTokenSeguridad(response: HttpResponse<IResponseData>) {
    sessionStorage.setItem('token', response.headers.get('authorization'));
  }

  cambiarIniPass(usuario: IUsuario): Observable<IResponseData> {
    return this.authApiService.cambiarIniPass(this.path, usuario).pipe(map(response => {
      if (response.codigo === Constante.RESPUESTA_OK) {
        this.borrarSessionStorage();
      } else {
      }
      return response;
    }));
  }

  cambiarPass(usuario: IUsuario): Observable<IResponseData> {
    return this.authApiService.cambiarPass(this.path, usuario).pipe(map(response => {
      if (response.codigo === Constante.RESPUESTA_OK) {
        this.borrarSessionStorage();
      } else {
      }
      return response;
    }));
  }

  logout(usuario: IUsuario): Observable<IResponseData> {
    this.borrarSessionStorage();
    this.router.navigate(['/login']);
    return
    /* return this.authApiService.logout(usuario).pipe(map(response => {
      if (response.codigo === Constante.RESPUESTA_OK) {
        this.borrarSessionStorage();
      } else {
      }
      return response;
    })); */
  }

  public borrarSessionStorage() {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('usuario');
    sessionStorage.removeItem('codigo_area');
    sessionStorage.removeItem('nombre_completo');
    sessionStorage.removeItem('fecha_registro');
    sessionStorage.removeItem('perfil');
    sessionStorage.removeItem('nivel');
  }

  obtenerPermisos(): IPermiso {
    return JSON.parse(sessionStorage.getItem('permisos'));
  }

  obtenerToken(): string {
    return sessionStorage.getItem('token');
  }

  obtenerNuevoToken(refreshToken: string): Observable<string> {
    return this.http.post<string>(`/auth/nuevo-token`, { refreshToken }, {
      observe: "body",
      responseType: "json"
    })
  }

  obtenerUsuario(): string {
    return sessionStorage.getItem('usuario');
  }

  obtenerPerfil(): string {
    return sessionStorage.getItem('perfil');
  }

  obtenerNombreCompleto(): string {
    return sessionStorage.getItem('nombre_completo');
  }

  obtenerUbicacion(): string {
    return sessionStorage.getItem('ubicacion');
  }

  obtenerNivelActual(): string {
    return sessionStorage.getItem('nivel');
  }

  obtenerSiguienteNivel(): string {
    const nivel = sessionStorage.getItem('nivel');
    const nivelDescompuesto = nivel.split('_');
    const nivelNumerico = Number(nivelDescompuesto[1]) + 1
    const siguienteNivel = nivelDescompuesto[0] + '_' + nivelNumerico;
    return siguienteNivel;
  }

  obtenerCodigoArea(): string {
    return sessionStorage.getItem('codigo_area');
  }

  obtenerCodigoAreaNomalizado(): string {
    const codigoArea = sessionStorage.getItem('codigo_area');
    return codigoArea.replace(/\//g, '//');
  }

  isLogueado(): boolean {
    let response: boolean;
    if (sessionStorage.getItem('token') === '' ||
      sessionStorage.getItem('token') === undefined ||
      sessionStorage.getItem('token') === null) {
      response = false;
    } else {
      response = true;
    }
    return response;
  }

}
